"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const input_checkbox_1 = require("../../components/input/input.checkbox");
const theme_1 = require("../../components/theme");
const tag_card_checkbox_style_1 = require("../tag.card.checkbox/tag.card.checkbox.style");
exports.CSS = {
    container: 'c-CollectionCard',
    containerLeft: 'c-CollectionCard__left',
    noLocation: 'c-CollectionCard--no-loc',
    link: 'c-CollectionCard__link',
    info: 'c-CollectionCard__info',
    filterMatch: 'c-CollectionCard__match',
    isHovered: 'c-CollectionCard--is-hovered',
    isInspected: 'c-CollectionCard--is-inspected',
    isSubtitle: 'c-CollectionCard__is-subtitle'
};
const CIRCLE_RADIUS = theme_1.DefaultTheme.spacingFactor * 2;
const CIRCLE_SIZE_PX = CIRCLE_RADIUS * 2 + 'px';
exports.Style = {
    [exports.CSS.container]: {
        display: 'flex',
        'align-items': 'center',
        'padding-left': theme_1.DefaultTheme.space(3),
        cursor: 'pointer',
        'border-left': `${theme_1.DefaultTheme.space(1)} solid transparent`,
        '&:hover': {
            backgroundColor: theme_1.DefaultTheme.font.color.divider
        }
    },
    [exports.CSS.noLocation]: {
        color: theme_1.DefaultTheme.font.color.disabled,
        cursor: 'default'
    },
    [exports.CSS.link]: {
        flex: '1',
        'padding-left': theme_1.DefaultTheme.space(3),
        overflow: 'hidden',
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis'
    },
    [exports.CSS.filterMatch]: {
        fontWeight: theme_1.DefaultTheme.font.weight.bold
    },
    [exports.CSS.isSubtitle]: {
        color: theme_1.DefaultTheme.font.color.supporting
    },
    [exports.CSS.info]: {
        flex: '1',
        color: theme_1.DefaultTheme.font.color.disabled,
        'font-size': '90%',
        'padding-right': theme_1.DefaultTheme.space(1),
        overflow: 'hidden',
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis',
        'text-align': 'right'
    },
    [exports.CSS.isHovered]: {
        'background-color': theme_1.DefaultTheme.font.color.hover
    },
    [exports.CSS.isInspected]: {
        'background-color': theme_1.DefaultTheme.background.offWhite,
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
        'border-color': theme_1.DefaultTheme.color.accent
    },
    [`${exports.CSS.container} .${tag_card_checkbox_style_1.CSS.container}`]: {
        width: CIRCLE_SIZE_PX,
        height: CIRCLE_SIZE_PX
    },
    [`${exports.CSS.container} .${input_checkbox_1.CSS.container} i`]: {
        'font-size': CIRCLE_SIZE_PX
    }
};
//# sourceMappingURL=collection.card.style.js.map